export default __webpack_public_path__ + "static/uCall x Giao Duc_page-0002-d33a7b12abb56d8cf970b0a6ad0ff5da.jpg";